// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["themes/gtl/css/ecommerce"], () => (__webpack_require__("./platform/themes/gtl/assets/js/main.js")))
__webpack_require__.O(undefined, ["themes/gtl/css/ecommerce"], () => (__webpack_require__("./platform/themes/gtl/assets/sass/style.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["themes/gtl/css/ecommerce"], () => (__webpack_require__("./platform/themes/gtl/assets/sass/ecommerce.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
